import { render, staticRenderFns } from "./UndeliveredMail.vue?vue&type=template&id=999dfe68"
import script from "./UndeliveredMail.vue?vue&type=script&lang=js"
export * from "./UndeliveredMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports